<script lang="ts" setup>
import { computed } from 'vue';
import { snackBarManager } from '../business/snackBarManager';
import SnackbarBase from './SnackbarBase.vue';
import { useSnackbarPadding } from '../business/useSnackbarPadding';
import { useMedia } from '@mm-frontend/mm-web-ui-kit';

// Определяем класс позиции контейнера на основе первого активного тоста или последней использованной позиции
const positionClass = computed(() => {
  return snackBarManager.snackBars.value.length
    ? snackBarManager.snackBars.value[0].position
    : snackBarManager.getLastUsedPosition();
});

const snackBars = computed(() =>
  snackBarManager.snackBars.value.slice(0, snackBarManager.maxSnackBarsShown.value)
);

const { isMobileOrTablet } = useMedia();

const additionalPadding = useSnackbarPadding();
const paddingBottom = computed(() => {
  return isMobileOrTablet.value ? 60 : 0 + additionalPadding.value;
});
</script>

<template>
  <TransitionGroup
    name="snackBar"
    tag="div"
    :class="['snackBar-container', positionClass]"
    :style="`padding-bottom: ${paddingBottom}px`"
  >
    <div v-for="snackBar in snackBars" :key="snackBar.id" class="snackBar-wrapper">
      <SnackbarBase
        :closable="snackBar.dismissible"
        :text="snackBar.message"
        :icon="snackBar.type"
        @close="snackBarManager.dismissSnackBar(snackBar.id)"
      />
    </div>
  </TransitionGroup>
</template>

<style scoped>
.snackBar-container {
  position: fixed;
  display: flex;
  flex-direction: column;
  gap: 10px;
  z-index: 1000;
  pointer-events: none;
  height: 100vh;
  width: 100vw;
  padding: 0 16px;
}

.snackBar-container.top-right {
  top: 20px;
  right: 20px;
}

.snackBar-container.top-left {
  top: 20px;
  left: 20px;
}

.snackBar-container.bottom-right {
  bottom: 20px;
  right: 20px;
}

.snackBar-container.bottom-left {
  bottom: 20px;
  left: 20px;
}

.snackBar-container.bottom {
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  justify-content: flex-end;
  align-items: center;
}

.snackBar-container.top {
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  justify-content: flex-start;
  align-items: center;
}

.snackBar-wrapper {
  pointer-events: auto;
  align-items: center;
}

/* Анимации */
.snackBar-enter-active,
.snackBar-leave-active {
  transition: all 0.5s ease;
}

.snackBar-enter-from,
.snackBar-enter {
  transform: translateY(-20px);
  opacity: 0;
}

.snackBar-enter-to {
  transform: translateY(0);
  opacity: 1;
}

.snackBar-leave-from {
  transform: translateY(0);
  opacity: 1;
}

.snackBar-leave-to {
  transform: translateY(-20px);
  opacity: 0;
}
</style>
